import { apiClient } from './apiClient';

export interface Doctor {
  id: string;
  name: string;
  photo?: string;
  image?: string;
  description?: string;
  link?: string;
  appointmentLink?: string;
  specializations?: { id: string; name: string }[];
  categories?: { id: string; name: string }[];
  branches?: { id: string; name: string }[];
}

export interface DoctorCategory {
  id: string;
  name: string;
  index: number;
}

export interface DoctorsFilter {
  categoryId?: string;
}

/**
 * Doctors API client
 */
export const doctorsService = {
  /**
   * Получить все категории врачей
   */
  getCategories: () => {
    return apiClient.get<{ categories: DoctorCategory[] }>('/webapp/doctors/categories');
  },

  /**
   * Получить врачей по категории
   */
  getDoctorsByCategory: (categoryId: string) => {
    return apiClient.get<{ doctors: Doctor[] }>(`/webapp/doctors/category/${categoryId}`);
  },

  /**
   * Получить всех врачей текущего филиала
   */
  getAllDoctors: () => {
    return apiClient.get<{ doctors: Doctor[] }>('/webapp/doctors/');
  },

  /**
   * Получить информацию о враче
   */
  getDoctor: (doctorId: string) => {
    return apiClient.get<{ doctor: Doctor }>(`/webapp/doctors/${doctorId}`);
  },

  /**
   * Получить специализации врачей
   */
  getSpecializations: () => {
    return apiClient.get<{ specializations: { id: string; name: string }[] }>('/webapp/doctors/specializations');
  },
};

